import { useState, useCallback } from 'react';
import { message } from 'antd';
import p201Api, { FP210, FP211 } from '../../../services/p201Api';

export function useP201Record() {
  const [record, setRecord] = useState<FP210 | null>(null);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async (id: string) => {
    setLoading(true);
    try {
      const data = await p201Api.get(id);
      setRecord(data);
      return data;
    } catch {
      message.error('載入失敗');
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const save = useCallback(async (
    master: Partial<FP210>,
    details: Partial<FP211>[],
    isNew: boolean
  ) => {
    setLoading(true);
    try {
      let result: FP210;
      if (isNew) {
        result = await p201Api.create(master, details);
        message.success('新增成功');
      } else {
        result = await p201Api.update(master.fp210_01!, master, details);
        message.success('儲存成功');
      }
      setRecord(result);
      return result;
    } catch (err: any) {
      if (err.response?.status === 422) {
        const errors = err.response.data.errors;
        if (errors?.length > 0) {
          message.error(errors.map((e: any) => e.message).join('\n'));
        }
        return null;
      }
      message.error('儲存失敗');
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const remove = useCallback(async (id: string) => {
    setLoading(true);
    try {
      await p201Api.delete(id);
      message.success('刪除成功');
      setRecord(null);
      return true;
    } catch {
      message.error('刪除失敗');
      return false;
    } finally {
      setLoading(false);
    }
  }, []);

  const clear = useCallback(() => setRecord(null), []);

  return { record, loading, load, save, remove, clear, setRecord };
}
